// A single verse, addressable at /verse/2/47.
import { html } from '../lib/html.js';
import { icon } from '../lib/icons.js';
import { actions, getProgress } from '../lib/store.js';
import { chapter, loadChapter, lessonForVerse, chapterSky } from '../lib/content.js';
import { topbar } from '../components/chrome.js';
import { verseBlock } from '../components/verse.js';
import { displayToggles, bindDisplayToggles } from './read.js';
import notfound from './notfound.js';

export default async function verseView({ ch: rc, v: rv }) {
  const ch = Number(rc);
  const v = Number(rv);
  const meta = ch >= 1 && ch <= 18 && String(ch) === rc ? chapter(ch) : null;
  if (!meta || !(v >= 1 && v <= meta.verses && String(v) === rv)) return notfound();
  const data = await loadChapter(ch);
  const verse = data.verseMap.get(v);
  const l = lessonForVerse(ch, v);
  const sky = chapterSky(ch);
  const prev = v > 1 ? `/verse/${ch}/${v - 1}` : ch > 1 ? `/verse/${ch - 1}/${chapter(ch - 1).verses}` : null;
  const next = v < meta.verses ? `/verse/${ch}/${v + 1}` : ch < 18 ? `/verse/${ch + 1}/1` : null;
  const famous = meta.famous.includes(`${ch}.${v}`);
  return {
    title: `Verse ${ch}.${v}`,
    html: html`<div class="verse-page" style="--sky-top:${sky.top};--sky-bottom:${sky.bottom};--sky-ink:${sky.ink}">
      ${topbar({ back: `/chapter/${ch}`, title: `Verse ${ch}.${v}` })}
      <div class="wrap">
        <header class="page-head verse-page__head">
          <p class="eyebrow"><a href="/chapter/${ch}">Chapter ${ch} · ${meta.title}</a></p>
          <h1 class="h1">Verse ${ch}.${v}</h1>
          <div class="verse-page__meta">
            <p class="muted">From the lesson <a class="text-link" href="/lesson/${l.id}">${l.title}</a></p>
            ${famous ? html`<span class="badge badge--accent">${icon('sparkles', { size: 14 })} Famous verse</span>` : ''}
          </div>
          ${displayToggles()}
        </header>
        ${verseBlock(ch, verse, { mode: 'page', headingLevel: 2 })}
        <nav class="pager section" aria-label="Verses">
          ${prev ? html`<a class="pager__link" href="${prev}" data-replace>${icon('arrow-left', { size: 18 })}<span><span class="pager__label">Previous</span><span class="pager__title">Verse ${prev.split('/').slice(2).join('.')}</span></span></a>` : html`<span></span>`}
          ${next ? html`<a class="pager__link pager__link--next" href="${next}" data-replace><span><span class="pager__label">Next</span><span class="pager__title">Verse ${next.split('/').slice(2).join('.')}</span></span>${icon('arrow-right', { size: 18 })}</a>` : ''}
        </nav>
        <div class="verse-page__more">
          <a class="btn btn--secondary" href="/read/${ch}#v-${ch}-${v}">${icon('read', { size: 18 })} Read in context</a>
        </div>
      </div>
    </div>`,
    mount(root) {
      bindDisplayToggles(root);
      if (!getProgress().verses[`${ch}.${v}`]) {
        const t = setTimeout(() => actions.markVerse(`${ch}.${v}`), 2000);
        return () => clearTimeout(t);
      }
      return null;
    },
  };
}
